export default {
    props: {
        tabObj: {}
    },
    
    data: function () {
        return {}
    }
}